<template functional>
  <v-row>
    <v-col
      v-for="item in 6"
      cols="12"
      sm="6"
      md="4"
      lg="3"
      :key="item"
    >
      <v-skeleton-loader
        type="card"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'ProductItemsLoading'
};
</script>
